var irreducible = require('./irreducible');
var isArray = require('./isArray');

module.exports = irreducible('Array', isArray);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Array.js
// module id = 735
// module chunks = 114276838955818